export default "__VITE_ASSET__Cwq0OkeC__"